import type { TicketActivity } from '../../domain/types'
import { ticketStatusLabel } from '../../domain/catalog'

const activityTimestamp = (iso?: string): number => {
  const timestamp = iso ? Date.parse(iso) : NaN
  return Number.isFinite(timestamp) ? timestamp : Number.NEGATIVE_INFINITY
}

const ticketHistoryTimeFormatter = new Intl.DateTimeFormat('pt-BR', {
  timeZone: 'America/Sao_Paulo',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
})

const formatTicketHistoryTime = (iso?: string): string | null => {
  if (!iso) {return null}
  const date = new Date(iso)
  return Number.isNaN(date.getTime()) ? null : ticketHistoryTimeFormatter.format(date)
}

export function adaptTicketHistory(response: unknown): TicketActivity[] {
  if (!response || typeof response !== 'object') {return []}
  const record = response as Record<string, unknown>
  const activities = (record.activities ?? record.Activities) as Record<string, unknown>[] | undefined
  if (!Array.isArray(activities)) {return []}

  const seen = new Set<string>()
  return activities
    .flatMap((activity, index) => {
      const rawLabel = String(activity.name ?? activity.Name ?? activity.status ?? activity.Status ?? '—')
      const rawTime = (activity.time ?? activity.Time) as string | undefined
      const duplicateKey = `${rawLabel}\u0000${rawTime ?? ''}`
      if (seen.has(duplicateKey)) {return []}
      seen.add(duplicateKey)
      return [{
        index,
        timestamp: activityTimestamp(rawTime),
        activity: {
          at: formatTicketHistoryTime(rawTime) ?? (rawTime ?? '—'),
          label: ticketStatusLabel(rawLabel) ?? rawLabel,
          by: null,
        } satisfies TicketActivity,
      }]
    })
    .sort((left, right) => right.timestamp - left.timestamp || left.index - right.index)
    .map(({ activity }) => activity)
}
